<template>
  <DpplTooltip location="bottom left">
    <template #activator="{ props }">
      <div
        class="internal-pill"
        :class="{ 'primary-color': isPrimaryColor }"
        v-bind="{ ...props, ...$attrs }"
      >
        {{ badgeText }}
      </div>
    </template>
    <div>
      <h5 class="mb-4">
        <slot name="title" />
      </h5>
      <p>
        <slot name="text" />
      </p>
    </div>
  </DpplTooltip>
</template>

<script>
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';

export default {
  name: 'JobBadge',
  components: { DpplTooltip },
  props: {
    badgeText: { type: String, default: '' },
    isPrimaryColor: { type: Boolean, default: false },
  },
};
</script>

<style lang="less" scoped>
.internal-pill {
  background-color: @white;
  border: 1px solid @grey-900;
  color: @text-darkest;
  font-size: 12px;
  font-weight: 500;
  padding: 0 8px;
  border-radius: 16px;
  letter-spacing: 0.75px;
  display: inline-block;

  &.primary-color {
    border-color: @text-brand;
    color: @text-brand;
  }
}
</style>
